import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import React, { useEffect, useState, useRef, useContext } from "react";
import TextInput from "./TextInput";
import { TabPanel, TabView } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { eventService } from "../services/EventService";
import { lookupsService } from "../services/LookupsService";
import { Toolbar } from "primereact/toolbar";
import { ProgressSpinner } from "primereact/progressspinner";
import { Divider } from "primereact/divider";
import { AppDB } from "../App";
import { Checkbox } from "primereact/checkbox";
import ScreenLoader from "./ScreenLoader";
import e from "cors";
import { BreadCrumb } from "primereact/breadcrumb";
import { InputNumber } from "primereact/inputnumber";

export default function AddEventPareameters({
	show = false,
	setShow,
	parametersList,
	setParametersList,
	form,
	setForm,
	eventCategoryID,
	isDelimitation = false,
	selectedCategory,
	setSelectedCategory,
	eventId,
	delimitationID,
	delimitationLeveId,
	setSavedEventParameters,
	savedEventParameters,
	IsOneDemarcationEvent
}) {
	const [showParameters, setshowParameters] = useState(true);
	const [parametersListUI, setParametersListUI] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [parameterGroups, setParameterGroups] = useState([]);
	const [parametersListErr, setParametersListErr] = useState([]);
	const { toast } = useContext(AppDB);
	useEffect(() => {
		GetEventCategoryParametersById(eventCategoryID);
		savedEventParameters.forEach((e) => {
			if (e?.parameter?.parameterTypeID === 4) {
				console.log(e);
				const startDate = e?.startDate ? new Date(e?.startDate) : " ";
				const endDate = e?.endDate ? new Date(e?.endDate) : startDate; // Default to startDate if null

				setParametersListUI((prevForm) => ({
					...prevForm,
					[e.parameterID]: [startDate, endDate]
				}));
				setParametersList((prev) => ({
					...prev,
					[e.parameterID]: {
						...(prev[e.parameterID] || {}),
						...{ parameterID: e.parameterID, value: e.value, startdate: startDate, enddate: endDate }
					}
				}));
			} else {
				setParametersList((prev) => ({
					...prev,
					[e.parameterID]: {
						...(prev[e.parameterID] || {}),
						...{ parameterID: e.parameterID, value: e.value, startdate: "", enddate: "" }
					}
				}));
			}
		});
	}, []);
	function GetEventCategoryParametersById(id) {
		setIsLoading(true);
		var payload = {
			EventCategoryID: id,
			ApplicabilityID: isDelimitation ? 2 : 1,
			IsOneDemarcationEvent: IsOneDemarcationEvent
		};
		eventService
			.GetCategoryParametersByAsync(payload)
			.then((data) => {
				setIsLoading(false);
				setParameterGroups(data);
				// setSelected(null);
			})
			.catch((err) => {
				setIsLoading(false);
				console.log(err);
			});
	}
	useEffect(() => {
		console.log("Updated parametersListUI:", parametersListUI);
		if (parametersListUI[1]) {
			isValid();
		}
	}, [parametersListUI]);
	function formatDateToDDMMYYYY(date) {
		return date ? `${date.getDate().toString().padStart(2, "0")}/${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getFullYear()}` : "";
	}

	const validateAllFormParameters = () => {
		let hasErrors = false;

		const newErrors = {};

		// // Validate eventCategory
		// if (form.eventCategory === null) {
		// 	newErrors.eventCategory = "Required";
		// 	hasErrors = true;
		// }

		// // Validate eventType
		// if (form.eventType === null) {
		// 	newErrors.eventType = "Required";
		// 	hasErrors = true;
		// }

		// Validate mandatory date parameters
		parameterGroups.forEach((group) => {
			group.parameters
				.filter((param) => param.mandotory)
				.forEach((element) => {
					const parameter = parametersList[element.parameterID];

					//null check
					if (!parameter) {
						newErrors[element.parameterID] = "Required.";
						hasErrors = true;
					}
					//date check
					else if (element?.parameterTypeID == 4 && !(parameter.startdate || parameter.enddate)) {
						newErrors[element.parameterID] = "Required.";
						hasErrors = true;
					}
					//value check
					else if (element?.parameterTypeID != 4 && !parameter.value) {
						newErrors[element.parameterID] = "Required.";
						hasErrors = true;
					}
				});
		});

		setParametersListErr((prevErrors) => ({ ...prevErrors, ...newErrors }));

		return !hasErrors;
	};

	function isValid() {
		let electionStartDate = null;
		let electionEndDate = null;
		let electionDate = null;
		let nominationDate = null;

		let hasErrors = false;

		// Find election period start and end dates
		parameterGroups.forEach((group) => {
			group.parameters.forEach((param) => {
				var parameter = parametersList[param.parameterID];

				if (parameter?.parameterID === 1) {
					// Election period
					electionStartDate = new Date(parameter.startdate);
					electionEndDate = new Date(parameter.enddate);
				}

				if (parameter?.parameterID === 2) {
					// Election day
					electionDate = new Date(parameter.startdate);
				}

				if (parameter?.parameterID === 7) {
					// Nomination day
					nominationDate = new Date(parameter.startdate);
				}
			});
		});

		// Ensure election period dates are valid
		if (!electionStartDate || !electionEndDate || isNaN(electionStartDate) || isNaN(electionEndDate)) {
			console.error("Invalid election period dates!");
			return; // Stop validation
		}

		console.log("Election Period:", electionStartDate, electionEndDate);

		const formattedElectionPeriod = `${formatDateToDDMMYYYY(electionStartDate)} - ${formatDateToDDMMYYYY(electionEndDate)}`;

		// Loop through parameters and validate their date ranges
		parameterGroups.forEach((group) => {
			group.parameters
				.filter((param) => param.mandotory)
				.forEach((element) => {
					var parameter = parametersList[element.parameterID];

					if (parameter?.startdate && parameter?.enddate) {
						const paramStartDate = new Date(parameter.startdate);
						const paramEndDate = new Date(parameter.enddate || parameter.startdate);

						console.log("Checking date:", paramStartDate, paramEndDate);
						if (!isNaN(paramStartDate) && !isNaN(paramEndDate)) {
							if (paramStartDate >= electionStartDate && paramEndDate <= electionEndDate) {
								setParametersListErr((prev) => ({
									...prev,
									[element.parameterID]: ""
								}));
							} else {
								setParametersListErr((prev) => ({
									...prev,
									[element.parameterID]: `Date must be within Election period ${formattedElectionPeriod}.`
								}));
								hasErrors = true;
							}
						}
					}
				});
		});

		// Validate nomination day vs election day (should be between 30-60 days before election)
		if (electionDate && nominationDate) {
			const dayDifference = Math.floor((electionDate - nominationDate) / (1000 * 60 * 60 * 24));

			if (dayDifference >= 30 && dayDifference <= 60) {
				setParametersListErr((prev) => ({
					...prev,
					7: ""
				}));
			} else if (dayDifference > 60) {
				setParametersListErr((prev) => ({
					...prev,
					7: "Nominations day cannot be more than 60 days before the election."
				}));
				hasErrors = true;
			} else if (dayDifference < 30) {
				setParametersListErr((prev) => ({
					...prev,
					7: "Nominations day cannot be less than 30 days before the election."
				}));
				hasErrors = true;
			}
		}
	}
	const handleInputChange = (value, parameterID, parameterType) => {
		let startdate = null;
		let enddate = null;
		let parameterValue = "";
		if (parameterType == 1 || parameterType == 2) {
			//number or string
			parameterValue = value;
		} else if (parameterType == 4) {
			//calender
			if (Array.isArray(value) && value.length > 0) {
				startdate = value[0];
				enddate = value.length == 1 ? startdate : value[1] || startdate;
			}
			setParametersListUI((prevForm) => ({ ...prevForm, [parameterID]: value }));
		}
		var updatedValue = { parameterID: parameterID, value: parameterValue, startdate: startdate, enddate: enddate };

		setParametersList((prev) => ({
			...prev,
			[parameterID]: {
				...(prev[parameterID] || {}),
				...updatedValue
			}
		}));
	};

	console.log(parametersList);

	function FormatDateToISO(date) {
		if (date) {
			return `${date.getFullYear().toString().padStart(4, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}T00:00:00.000Z`;
		}
		return null;
	}
	function SubmitEventDelimitationParameter() {
		if (!validateAllFormParameters()) {
			toast.show({
				severity: "error",
				summary: "Validation Error",
				detail: "Please correct the errors before submitting.",
				life: 3000
			});
			return;
		}
		setIsLoading(true);

		var parameters = [];
		Object.keys(parametersList).forEach((key) => {
			parameters.push({
				parameterID: parametersList[key].parameterID,
				value: parametersList[key].value?.toString(),
				startdate: FormatDateToISO(parametersList[key].startdate),
				enddate: FormatDateToISO(parametersList[key].enddate)
			});
		});
		const payload = {
			EventID: eventId,
			EventDelimitationID: delimitationID,
			EventDelimitationLevelID: delimitationLeveId,
			EventParameters: parameters,
			EventCategoryID: eventCategoryID
		};

		eventService
			.AddEventDelimitationParameter(payload)
			.then((data) => {
				setIsLoading(false);
				if (data.success) {
					toast.show({
						severity: "success",
						summary: "Success Message",
						detail: data?.message,
						life: 2000
					});
					setSavedEventParameters();
					setShow(false);
				} else {
					const serverErrors = {};

					data.data?.forEach((element) => {
						serverErrors[element.parameterID] = element.message;
					});
					setParametersListErr(serverErrors);
					return toast.show({
						severity: "error",
						summary: "Error Message",
						detail: data?.message,
						life: 2000
					});
				}
			})
			.catch((err) => {
				setIsLoading(false);
				console.log(err);
				return toast.show({
					severity: "error",
					summary: "Message",
					detail: "There is a technical problem fetching event staff, Please Try Again",
					life: 3000
				});
			});
	}

	return (
		<Dialog
			visible={show}
			onHide={() => setShow(false)}
			style={{ height: "98%", width: "98%" }}
			header={"Election Timetable"}
			footer={
				<>
					<Button
						label="Close"
						onClick={(e) => {
							setShow(false);
						}}
						className="p-button-danger"
					/>
					<Button
						loading={isLoading}
						className="p-button-success"
						label="Save"
						onClick={() => {
							// setIsLoading(true);
							SubmitEventDelimitationParameter();
						}}
					/>
				</>
			}
		>
			{isLoading && <ScreenLoader visible={{ isLoading }} />}
			<div>
				{showParameters && (
					<>
						<br />
						<br />
						<b>Event Parameters</b>
						{/* Mandatory parameters */}
						{parameterGroups
							.filter((group) => group.parameters.some((param) => param.mandotory))
							.map((group) => (
								<section>
									<div className="flex flex-wrap gap-4">
										<h5 className="m-0">{group.parameterGroupID == 1 ? <></> : <b>{group.name}</b>}</h5>
									</div>
									<div className="flex flex-wrap">
										{group.parameters
											.filter((param) => param.mandotory)
											.map((param) => (
												<>
													{param.parameterTypeID == 1 && ( //number
														<div style={{ width: "50%" }}>
															<label>
																{param.name} {param.mandotory && <span className="text-error">*</span>}
															</label>
															<InputNumber
																tooltip={param.description}
																style={{ width: "99%" }}
																value={parametersList[param.parameterID]?.value || null}
																onValueChange={(e) =>
																	handleInputChange(e.target.value, param.parameterID, param.parameterTypeID)
																}
																useGrouping={false}
															/>
															<label style={{ color: "red", marginBottom: "5px" }}>
																{parametersListErr[param.parameterID]}
															</label>
														</div>
													)}
													{param.parameterTypeID == 2 && ( //String
														<div style={{ width: "50%" }}>
															<label>
																{param.name} {param.mandotory && <span className="text-error">*</span>}
															</label>
															<TextInput
																maxLength={2000}
																tooltip={param.description}
																style={{ width: "99%" }}
																value={parametersList[param.parameterID]?.value || ""}
																onChange={(e) =>
																	handleInputChange(e.target.value, param.parameterID, param.parameterTypeID)
																}
															/>
															<label style={{ color: "red", marginBottom: "5px" }}>
																{parametersListErr[param.parameterID]}
															</label>
														</div>
													)}
													{param.parameterTypeID == 4 && ( //Date
														<div style={{ width: "50%" }}>
															<label>
																{param.name} {param.mandotory && <span className="text-error">*</span>}
															</label>
															<Calendar
																tooltip={param.description}
																dateFormat="dd/mm/yy"
																placeholder="dd/mm/yy"
																style={{ width: "99%" }}
																value={parametersListUI[param.parameterID]}
																onChange={(e) =>
																	handleInputChange(e.target.value, param.parameterID, param.parameterTypeID)
																}
																showTime={false}
																showIcon={true}
																selectionMode="range"
																hideOnRangeSelection
															/>
															<label style={{ color: "red", marginBottom: "5px" }}>
																{parametersListErr[param.parameterID]}
															</label>
														</div>
													)}
												</>
											))}
									</div>
									<br />
									<br />
								</section>
							))}
						<br />
						<br />
						{/* Optional Parameters */}
						<b>Optional Fields (Please tick to add a field)</b>
						{parameterGroups
							.filter((group) => group.parameters.some((param) => !param.mandotory))
							.map((group) => (
								<section>
									<div className="flex flex-wrap gap-4">
										<h5 className="m-0">{group.parameterGroupID == 1 ? <></> : <b>{group.name}</b>}</h5>
									</div>
									<div className="flex flex-wrap">
										{group.parameters
											.filter((param) => !param.mandotory)
											.map((param) => (
												<>
													{param.parameterTypeID == 1 && ( //number
														<div style={{ width: "50%" }}>
															<label>
																{param.name} {param.mandotory && <span className="text-error">*</span>}
															</label>
															<InputNumber
																tooltip={param.description}
																style={{ width: "99%" }}
																value={parametersList[param.parameterID]?.value || null}
																onValueChange={(e) =>
																	handleInputChange(e.target.value, param.parameterID, param.parameterTypeID)
																}
																useGrouping={false}
															/>
															<label style={{ color: "red", marginBottom: "5px" }}>
																{parametersListErr[param.parameterID]}
															</label>
														</div>
													)}
													{param.parameterTypeID == 2 && ( //String
														<div style={{ width: "50%" }}>
															<label>
																{param.name} {param.mandotory && <span className="text-error">*</span>}
															</label>
															<TextInput
																tooltip={param.description}
																style={{ width: "99%" }}
																value={parametersList[param.parameterID]?.value || ""}
																onChange={(e) =>
																	handleInputChange(e.target.value, param.parameterID, param.parameterTypeID)
																}
															/>
														</div>
													)}
													{param.parameterTypeID == 4 && ( //Date
														<div style={{ width: "50%" }}>
															<label>
																{param.name} {param.mandotory && <span className="text-error">*</span>}
															</label>
															<Calendar
																tooltip={param.description}
																style={{ width: "99%" }}
																value={parametersListUI[param.parameterID]}
																onChange={(e) => handleInputChange(e.value, param.parameterID, param.parameterTypeID)}
																showTime={false}
																showIcon={true}
																selectionMode="range"
																dateFormat="dd/mm/yy"
																placeholder="dd/mm/yy"
																hideOnRangeSelection
															/>
															<label style={{ color: "red", marginBottom: "5px" }}>
																{parametersListErr[param.parameterID]}
															</label>
														</div>
													)}
												</>
											))}
									</div>
									<br />
									<br />
								</section>
							))}
					</>
				)}
			</div>
		</Dialog>
	);
}
